import { getLocation } from 'connected-react-router';
import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';

import { CirclePerson2, Toast } from '../../../../brenger-shared-ui';
import { useTypedSelector } from '../../../../hooks';
import { useNotification } from '../../../../hooks/useNotification';
import { r } from '../../../../routes';
import { getAccountIsEligibleForDeferredVat, getIsGuestEligibleForDeferredVat } from '../../../User/ducks';

export const DeferredVatNotification: React.FC = () => {
  const notification = useNotification('vat-deferred');
  const { pathname } = useTypedSelector(getLocation);
  const isDeferredVat = useTypedSelector(
    state => getAccountIsEligibleForDeferredVat(state) || getIsGuestEligibleForDeferredVat(state)
  );
  const isContactOrTermsPage =
    pathname.startsWith(r.generalFlow.contact.index()) || pathname.startsWith(r.generalFlow.terms.index());

  React.useEffect(() => {
    if (isContactOrTermsPage && isDeferredVat) {
      notification.add();
    } else {
      notification.remove();
    }
  }, [isContactOrTermsPage, isDeferredVat]);

  return (
    <Toast
      isVisible={notification.isVisible}
      prefix={<CirclePerson2 />}
      handleClose={notification.removeForOneSession}
      title={<Translate id="request_flow.vat_deferred.notification.header" />}
      body={<Translate id="request_flow.vat_deferred.notification.text" />}
    />
  );
};
